import clsx from 'clsx';
import React from 'react';
import { ResponsiveContainer, Pie, PieChart, Label, Cell } from 'recharts';

type Graphic = {
  name: string;
  value: number;
};

type PieChartComponentProps = {
  graphic: Graphic[];
  percent: number;
  innerRadius?: number;
  outerRadius?: number;
  labelClassName?: string;
};

const COLORS = ['var(--sector-background)', 'var(--completed)'];

export const DoughPieChart: React.FC<PieChartComponentProps> = ({
  graphic,
  percent,
  innerRadius = 20,
  outerRadius = 28,
  labelClassName,
}) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie
          data={graphic}
          dataKey="value"
          cornerRadius={8}
          paddingAngle={4}
          outerRadius={outerRadius}
          innerRadius={innerRadius}
          isAnimationActive={false}
        >
          {COLORS.map((_entry, index) => (
            <Cell
              key={`cell-${index}`}
              className="rounded-xs"
              fill={COLORS[index % COLORS.length]}
            />
          ))}
          <Label
            fill="darkText"
            position="center"
            value={`${percent}%`}
            className={clsx(labelClassName, 'text-small font-bold')}
          />
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
};
